import { ProgressStep } from '.';
import { ProgressIndicatorType } from './ProgressIndicatorType';
import CircleProgressIndicator from './circleProgressIndicator/CircleProgressIndicator';
import HorizontalProgressIndicator from './horizontalProgressIndicator/HorizontalProgressIndicator';

export interface ProgressIndicatorProps {
  indicatorType?: ProgressIndicatorType;
  steps: ProgressStep[];
  activeStepIndex: number;
  onCompletedStepClicked?: (stepIndex: number) => void;
}

const ProgressIndicator: React.FC<ProgressIndicatorProps> = (
  props: ProgressIndicatorProps
) => {
  const {
    indicatorType = ProgressIndicatorType.HorizontalSteps,
    steps = [],
    activeStepIndex = 0,
  } = props;

  const totalSteps = steps.length;
  const percentComplete =
    totalSteps <= 1 || activeStepIndex === 0
      ? 0
      : (100 / (totalSteps - 1)) * activeStepIndex;

  const onCompletedStepClicked = (stepIndex: number) => {
    props.onCompletedStepClicked && props.onCompletedStepClicked(stepIndex);
  };

  return (
    <>
      {indicatorType === ProgressIndicatorType.Circle ? (
        <CircleProgressIndicator
          steps={steps}
          activeStepIndex={activeStepIndex}
          percentComplete={percentComplete}
          onBackClicked={() => onCompletedStepClicked(activeStepIndex - 1)}
        />
      ) : (
        <HorizontalProgressIndicator
          steps={steps}
          activeStepIndex={activeStepIndex}
          percentComplete={percentComplete}
          onCompletedStepClicked={onCompletedStepClicked}
          onBackClicked={() => onCompletedStepClicked(activeStepIndex - 1)}
        />
      )}
    </>
  );
};

export default ProgressIndicator;
